module.exports = __webpack_public_path__ + "static/media/DSCF0771-01.7f9b4936.jpg";